var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Icons"}},[_c('div',{staticClass:"vx-row"},_vm._l((_vm.icons),function(icon,index){return _c('div',{key:index,staticClass:"vx-col w-1/4 mt-6"},[_c('label',{staticClass:"label-icon"},[_vm._v(_vm._s(icon.class))]),_c('img',{staticClass:"icon",attrs:{"src":icon.url}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }